export default __webpack_public_path__ + "static/media/intro-1.733d5b68.jpg";